import React from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { messages } from './KioskQuestionnaires.i18n';

const actionCell = (_, data, handleClick) => (
  data.canStartByPatient ?
    <Button
      aria-describedby="button_description"
      onClick={handleClick(data.patientId)}
    >
      <FormattedMessage {...messages.page.startButtonText} />
    </Button>
    : <FormattedMessage {...messages.page.labels.inactiveQuestionnaire} />
);


export const getColumns = (language, handleClick) => [
  {
    name: messages.columnHeader.patientName,
    dataField: 'firstname',
    dataCellCss: 'kiosk-questionnare-col',
    headerCellCss: 'kiosk-questionnaire-col',
    renderField: (_, data) => (
      <FormattedMessage
        { ...messages.sortedDisplayNameFormat }
        values={{
          0: data.firstName,
          1: data.lastName,
        }}
      />
    ),
  },
  {
    name: messages.columnHeader.dateOfBirth,
    dataField: 'dateOfBirth',
    dataCellCss: 'kiosk-questionnare-col',
    headerCellCss: 'kiosk-questionnaire-col',
    renderField: (_, data) =>
      moment(data.dateOfBirth).locale(language).format('L'),
  },
  {
    name: messages.columnHeader.mrn,
    dataField: 'mrn',
    dataCellCss: 'kiosk-questionnare-col',
    headerCellCss: 'kiosk-questionnaire-col',
  },
  {
    name: messages.columnHeader.facilityShortName,
    dataField: 'facilityShortName',
    dataCellCss: 'kiosk-questionnare-col',
    headerCellCss: 'kiosk-questionnaire-col',
  },
  {
    name: messages.columnHeader.numberQuestionnaires,
    dataField: 'questionnaireTitles',
    dataCellCss: 'kiosk-questionnare-col',
    headerCellCss: 'kiosk-questionnaire-col',
    renderField: (_, data) => data.questionnaireTitles.length,
  },
  {
    name: '',
    formatted: true,
    dataField: 'canStartByPatient',
    dataCellCss: 'kiosk-questionnare-col',
    headerCellCss: 'kiosk-questionnaire-col',
    renderField: (fieldValue, data) => actionCell(fieldValue, data, handleClick),
  },
];

